var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import server from '../server';
import IconFont from '../IconFont';
export function convertEmployeeToString(employee) {
    return employee.userId + ":" + employee.appId + ":" + employee.teamId;
}
export function getIsSelf(self, other) {
    if (self === void 0) { self = {}; }
    if (other === void 0) { other = {}; }
    if (!self || !other) {
        return false;
    }
    return ((self.userId || self.pin) === (other.userId || other.pin) &&
        (self.appId || self.app) === (other.appId || other.app) &&
        self.teamId === other.teamId);
}
// 人员标签属性展示 （未认证、外部、单位领导、管理员等）
export function tagsNode(labelInfoList) {
    return labelInfoList === null || labelInfoList === void 0 ? void 0 : labelInfoList.map(function (label, key) {
        return label.isShow === '1' ? (React.createElement("span", { key: key, className: "user-tags", style: {
                color: "#" + label.color,
                background: "#" + label.color + "10"
            } }, label.name)) : null;
    });
}
export var Line = function () {
    var style = {
        background: '#eeeeee',
        height: '1px',
        margin: '4px 0'
        // width: 'calc(100% - 20px)'
        // float: 'right',
        // margin: '0 0 0 20px'
    };
    return React.createElement("div", { style: style });
};
export var SplitLine = function () {
    return React.createElement("div", { className: "usercard-item-splitline" });
};
export var getSexNode = function (sex) {
    if (!sex || sex === '2') {
        return '';
    }
    else if (sex === '0') {
        return React.createElement(IconFont, { style: { color: '#FF6792' }, type: "iconapp_sex_female" });
    }
    else {
        return React.createElement(IconFont, { style: { color: '#2E8EFF' }, type: "iconapp_sex_male" });
    }
};
// eslint-disable-next-line max-params
export var getUserCardDetail = function (params, accessToken, env_pre, source) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, server.ebook.getUserCardDetailInfo(params, accessToken, env_pre, source)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=common.js.map